import http from './http.service';
import { RegisterFieldValueQueryFilter } from '../models/enums';

class AuxiliaryRegisterService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/auxiliaryRegisters";
    }

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activate`, { params: { id: id } });
    }

    deactivate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivate`, { params: { id: id } });
    }

    getDetails(id, filter) {
        if (filter === RegisterFieldValueQueryFilter.All) {
            return this.$http.get(`${this.baseUrl}/${id}/allFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.Active) {
            return this.$http.get(`${this.baseUrl}/${id}/activeFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.ShowInDescription) {
            return this.$http.get(`${this.baseUrl}/${id}/showInDesctiptionFieldsDetails`);
        } else {
            return this.$http.get(`${this.baseUrl}/${id}/showInDesctiptionFieldsDetails`);
        }
    };
}

export default new AuxiliaryRegisterService();
